import * as React from 'react';
import { useSelector } from 'react-redux';

import { BASE_FILTERS_URL, SEO_URL_REGEXP } from '../../../common/constants/urls';
import { selectFiltersUrl } from '../../../common/selectors/urls';
import { IApplicationState } from '../../../common/types/redux';
import { Chip, FiltersButton } from '../../components/RedesignedFilters';

export const FiltersChipContainer = () => {
  const filtersUrl = useSelector<IApplicationState, string | null>(selectFiltersUrl);

  const handleClick = React.useCallback(
    (event: React.MouseEvent<HTMLButtonElement, MouseEvent>) => {
      event.preventDefault();

      const isSeoUrl = SEO_URL_REGEXP.test(window.location.pathname);
      const searchStringFromLocation = window.location.search;
      const safeFiltersUrlFromState = filtersUrl || BASE_FILTERS_URL;

      setTimeout(() => {
        document.cookie = 'flavour=mobile;domain=.cian.ru;path=/';

        if (isSeoUrl) {
          window.location.href = safeFiltersUrlFromState;
        } else if (searchStringFromLocation) {
          window.location.href = `/nd/search/${searchStringFromLocation}`;
        } else {
          window.location.href = safeFiltersUrlFromState;
        }
      }, 300);
    },
    [filtersUrl],
  );

  return (
    <Chip hasChevron={false} asButton={false}>
      <FiltersButton hasActiveFilters onClick={handleClick} />
    </Chip>
  );
};
